<template>
  <div class="content">
    <NavbarInstrument></NavbarInstrument>
    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2" v-html="error.text"></p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
        </div>
      </v-sheet>
    </v-dialog>
    <!-- failed -->
    <v-dialog v-model="failed.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="m-4 text-medium-emphasis text-body-2">
          {{  failed.text  }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import axios from 'axios';
  import moment from 'moment';
  import Params from '@/models/params';
  import NavbarInstrument from '@/components/navbar/NavbarInstrument.vue';
  import { ref, reactive, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  const router = useRouter();
  const route = useRoute();
  const code = route.params.code;
  const params = ref(new Params);
  const process = ref(true);
  const error = reactive({
    state: null,
    text: null
  })
  const failed = reactive({
    state: null,
    text: null
  })

  onMounted(() => {
    search();
  });

  async function search(){
    try {
      const frm = new FormData;
      frm.append('code', code);
      await axios.post(params.value.api + 'instrumentos/buscar', frm)
      .then( r => {
        const d = r.data.data;
        if(moment(d.desde).diff(moment(), 'days') > 0){
          process.value = false;
          failed.text = 'Este instrumento todavía no se encuentra habilitado.';
          failed.state = true;
        }else if(moment(d.hasta).diff(moment(), 'days') < 0){
          process.value = false;
          failed.text = 'Este instrumento ya no admite más respuestas, por favor contacta con un colaborador de United Way Colombia.';
          failed.state = true;
        }else{
          localStorage.instrumentId = d.idinstrumento;
          localStorage.instrumentAssesment = d.id;
          localStorage.instrumentName = d.instrumento;
          localStorage.instrumentType = d.tipo;
          localStorage.instrumentSetting = d.configuracion;
          localStorage.instrumentDescription = d.descripcion;
          switch (d.configuracion) {
            case 'clasico':
              router.push({name: 'instrumentclassic'});
              break;
            case 'adaptativo':
              router.push({name: 'instrumentadaptative'});
              break;
          }
        }        
      })
      .catch( (error) => {
        error.text = error.data.message;
        error.state = true;
      });
    } catch (error) {
      error.text = error;
      error.state = true;
    }
  }
</script>